/**
 * authConfig.js
 *
 * Environment-driven AWS Cognito authentication configuration for Amplify JS v6.
 * Decouples frontend authentication from the legacy Amplify Gen 1 CLI backend
 * by configuring authentication directly from environment variables.
 *
 * References:
 * - REL-1396: Audit Cognito token parsers & Amplify Gen 1 decoupling
 * - REL-1376: Decommission deprecated AWS Pinpoint analytics
 */

const BASE_COGNITO_SETTINGS = {
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [
    'BIRTHDATE',
    'GENDER',
    'PHONE_NUMBER',
    'EMAIL',
    'FAMILY_NAME',
    'NAME',
  ],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
      'REQUIRES_UPPERCASE',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export const getAuthConfig = () => ({
  ...BASE_COGNITO_SETTINGS,
  aws_project_region: process.env.REACT_APP_COGNITO_REGION,
  aws_cognito_region: process.env.REACT_APP_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
  // Ensure dead Pinpoint analytics configuration is stripped out (REL-1376)
  Analytics: undefined,
});

export default getAuthConfig();
